<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-input size="mini" placeholder="请输入客户名称/项目名称" v-model="keyword" clearable style="width: 200px"></el-input>
          <el-input size="mini" placeholder="请输入负责人" v-model="contract_leader" clearable style="width: 200px"></el-input>
          <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
            <el-option
              v-for="item in business_list"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>

          <el-date-picker
            size="mini"
            v-model="where_time"
            unlink-panels
            type="monthrange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>

          <el-button size="mini" type="primary" @click="search">搜索</el-button>

          <div style="width: 30px;display: inline-block;"></div>


<!--          - -->
          <el-button size="mini" type="primary" @click="download">导出报表</el-button>
          <el-button size="mini" type="primary" @click="downloadHistory">导出历史报表</el-button>
<!--          <el-button size="mini" type="primary" @click="importExcel">导入</el-button>-->
        </div>

        <div class="table-wrap">
          <el-table ref="elTable" v-if="pageData" v-loading="loading" :data="pageData.list" :border="true" :cell-style="cellStyle" height="680px">
            <el-table-column label="序号" align="center" fixed="left" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.contract_area !== '合计'" v-text="scope.$index + 1 + (pageData.page - 1) * pageData.pageSize"></span>
              </template>
            </el-table-column>
            <el-table-column prop="contract_area" label="区域" align="center" fixed="left" width="200"></el-table-column>
            <el-table-column prop="contract_leader" label="负责人" align="center" fixed="left" width="80"></el-table-column>
            <el-table-column prop="party_a" label="客户名称" align="center" fixed="left" width="200"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" fixed="left" width="150"></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" fixed="left" width="80"></el-table-column>
            <el-table-column prop="contract_price" label="合同总价" align="center" fixed="left" width="100"></el-table-column>


            <template v-for="item in month_list">
              <el-table-column prop="month" :label="item" align="center" width="160">
                <el-table-column label="已开票" align="center" width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.month_value_list[item]['invoiced']>0" style="color: #ff3d00">
                      {{scope.row.month_value_list[item]['invoiced']}}</span>
                    <span v-if="scope.row.month_value_list[item]['invoiced'] ===undefined" style="color: #343436">
                      {{scope.row.month_value_list[item]['invoiced']}}</span>
                    <span v-if="scope.row.month_value_list[item]['invoiced'] ==='0.00'" style="color: #26a803">
                      {{scope.row.month_value_list[item]['invoiced']}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="未开票" align="center" width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.month_value_list[item]['not_invoice']>0" style="color: #ff3d00">
                      {{scope.row.month_value_list[item]['not_invoice']}}</span>
                    <span v-if="scope.row.month_value_list[item]['not_invoice'] ===undefined" style="color: #343436">
                      {{scope.row.month_value_list[item]['not_invoice']}}</span>
                    <span v-if="scope.row.month_value_list[item]['not_invoice'] ==='0.00'" style="color: #26a803">
                      {{scope.row.month_value_list[item]['not_invoice']}}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>

            <el-table-column prop="all_arrearage_amount" label="累计欠费（元）" align="center" width="100"></el-table-column>
            <el-table-column prop="all_uninvoiced_amount" label="未开票金额" align="center" width="100"></el-table-column>
            <el-table-column prop="all_invoiced_amount" label="已开票金额" align="center" width="100"></el-table-column>


          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="download_visible" title="下载进度" width="350" @close="download_visible = false">
      <div>
        <el-progress :percentage="download_progress"></el-progress>
  </div>
    </el-dialog>
  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";

export default {
  name:"ArrearageAging",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        month:"",
        contract_id:"",
        month_key:"",
        amount:"",
        invoice_amount:"",
        paid_amount:"",
        status:"",
        is_end:"",
        is_invoice:"",
        is_paid:"",
        files:"",
        remarks:"",
      },
      month_value:"",
      business_list:[],
      entry_type_name:"",
      multipleSelection:[],
      f_status:"",
      month_keys:{},
      where_time:"",
      contract_leader : '',
      // 拆分下载
      download_visible : false,
      download_progress : 0,
      cache_key : '',
      cache_page : 1,
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.month_value=CommonHelp.date("YYYY-MM");
    this.where_time=[CommonHelp.date("YYYY-01"),CommonHelp.date("YYYY-MM")]
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  computed:{
    month_list(){
      var that=this;
      let list=Object.keys(that.month_keys);
      list.sort();
      return list;
    },
    search_params() {
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      this.where_time&&(where.where_time=this.where_time);
      where['c.contract_leader'] = this.contract_leader;
      return where;
    }
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      CommonHelp.get("ArrearageAging/getList",{
        where:JSON.stringify(this.search_params),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.month_keys={};
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            let month_keys=ret.month_value_list
            that.month_keys={
              ...that.month_keys,
              ...month_keys
            }
            return ret;
          })
          that.pageData=res.data
          that.$nextTick(() => {
            that.$refs.elTable.doLayout()
          });
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      CommonHelp.get("ArrearageAging/exportExcel",{
        where:JSON.stringify(this.search_params),
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        cache_key : this.cache_key,
        cache_page : this.cache_page
      },res=>{
        if(res.code) {
          let is_finish = res.data.is_finish;
          if(is_finish){
            that.download_visible = false;
            let url = res.data.url;
            window.open(that.host_url + url)
          }else{
            that.download_progress = parseFloat(((that.cache_page - 1) / res.data.total * 100).toFixed(2));
            that.cache_key = res.data.cache_key;
            that.cache_page = res.data.cache_page;
            that.exportExcel();
          }
        }
      })
    },
    download(){
      this.cache_key = '';
      this.cache_page = 1;
      this.download_progress = 0;
      this.download_visible = true;
      this.exportExcel();
    },
    downloadHistory(){
      this.cache_key = '';
      this.cache_page = 1;
      this.download_progress = 0;
      this.download_visible = true;
      this.exportExcelHistory();
    },
    exportExcelHistory(){
      var that=this;
      CommonHelp.get("ArrearageAging/exportExcelHistory",{
        where:JSON.stringify(this.search_params),
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        cache_key : this.cache_key,
        cache_page : this.cache_page
      },res=>{
        if(res.code) {
          let is_finish = res.data.is_finish;
          if(is_finish){
            that.download_visible = false;
            let url = res.data.url;
            window.open(that.host_url + url)
          }else{
            that.download_progress = ((that.cache_page - 1) / res.data.total * 100).toFixed(2);
            that.cache_key = res.data.cache_key;
            that.cache_page = res.data.cache_page;
            that.exportExcelHistory();
          }
        }
      })
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    cellStyle({row, column, rowIndex, columnIndex}){
      if(columnIndex>5){
        let row_keys=Object.keys(row);
        // console.log(row_keys,row[row_keys[columnIndex]])
        // if(row[row_keys[columnIndex]]===undefined){
        //   return {background:'#090909'}
        // }else if(row[row_keys[columnIndex]]==='0.00'){
        //   return {background:'#039f03'}
        // }else {
        //   return {background:'#f51313'}
        // }
      }
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ArrearageAging.vue